import { render } from "./clearCacheTask.vue?vue&type=template&id=5383ad18&ts=true"
import script from "./clearCacheTask.vue?vue&type=script&lang=ts"
export * from "./clearCacheTask.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__